<template>
  <div>
    <h2 v-if="!placeId">場所を追加する</h2>
    <h2 v-if="placeId">場所を編集する</h2>
    <b-form @submit.prevent="sendItem">
      <b-form-group id="input-group-name" label="場所の名前" label-for="input-2">
        <b-form-input id="input-name" v-model="form.name" required placeholder="場所の名前"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-description" label="お店の詳細" label-for="input-description">
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="お店の詳細"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group id="input-group-img-url" label="画像URL" label-for="input-img-url">
        <b-form-file
          placeholder="画像をドロップするかクリックして選択"
          drop-placeholder="ここにドロップ"
          v-on:change="uploadfile"
        ></b-form-file>
        <img :src="form.imgUrl" v-if="form.imgUrl" width="300" />
      </b-form-group>
 
      <b-form-group id="input-group-img-url" label="営業時間" label-for="input-img-url">
        <b-form-input v-model="form.hour" placeholder="10:00-18:00, 24時間営業"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-img-url" label="種別" label-for="input-img-url">
        <b-form-select v-model="form.type" :options="types"></b-form-select>
      </b-form-group>

      <b-form-group id="input-group-img-url" label="地図上の場所" label-for="input-img-url">
        <b-form-input v-model="form.latLng" placeholder="37.6283132,140.989484"></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" v-if="!placeId">追加する</b-button>
      <b-button type="submit" variant="primary" v-if="placeId">編集する</b-button>
      <b-button variant="danger" v-if="placeId" v-on:click="deleteItem">削除する</b-button>
    </b-form>
  </div>
</template>

<script>
import { db, storage } from "@/firebase/firebase";
export default {
  name: "NewPlace",
  data() {
    return {
      form: {},
      placeId: null,
      types: [
        { value: null, text: "種別を選んでください" },
        { value: "food", text: "飲食店" },
        { value: "shop", text: "小売店" },
        { value: "spot", text: "観光スポット" },
        { value: "person", text: "地元の有名人" }
      ]
    };
  },
  mounted: function() {
    if (this.$route.params.placeId) this.placeId = this.$route.params.placeId;
  },
  methods: {
    //ここから追加（上のコンマもわすれない）
    sendItem() {
      const router = this.$router;
      const placeId = this.placeId;
      const collection = db.collection("places");
      if (placeId) {
        //this.form.placeIdじゃなかった
        //もしIDがあったら＝登録済みのデータなら、更新モード
        collection
          .doc(placeId)
          .set(this.form)
          .then(function(docRef) {
            router.push("/place/" + placeId);
          })
          .catch(function(error) {
            console.error("Error editting document: ", error);
          });
      } else {
        //なければ今までと一緒で新規作成
        collection
          .add(this.form)
          .then(function(docRef) {
            router.push("/place/" + docRef.id);
          })
          .catch(function(error) {
            console.error("Error adding document: ", error);
          });
      }
    },
    deleteItem() {
      const router = this.$router;
      const placeId = this.placeId;
      const collection = db.collection("places");
      if (confirm("本当に削除してしまってもよろしいですか？")) {
        collection.doc(placeId).delete();
        router.push("/");
      }
    },
    uploadfile(e) {
      const file = e.target.files[0] 
      const form = this.form
      let storageRef = storage.ref();
      let imgRef = storageRef.child("uploads/" + file.name);
      imgRef.put(file).then(
        function(snapshot) {
          snapshot.ref.getDownloadURL().then(
            function(downloadURL) {
              form.imgUrl = downloadURL
            },
            function(error) {
              alert('ダウンロードURLの取得でエラーが発生しました')
            }
          );
        },
        function(error) {
          alert('アップロードでエラーが発生しました')
        }
      );
    },
  },
  firestore() {
    return {
      form: db.collection("places").doc(this.$route.params.placeId)
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/NewPlace.vue